export default {
  options: {
    true: 'Sì',
    false: 'No',
  },
};
